// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Block2_wrapper__1Em2L"};